class CompareDrawer extends HTMLElement {
  constructor() {
    super();

		this.onChange = this.onChange.bind(this);
		this.updateHeightVariable = this.updateHeightVariable.bind(this);	

    const compareBanner = this;
    let compareCheckboxes = document.querySelectorAll('.product-compare-checkbox');

    const selectedCounts = this.querySelectorAll('.compare-banner__top-counter');
    this.compareBannerItems = this.querySelector('.compare-banner__product-items');
    let compareProductsList = JSON.parse(localStorage.getItem('compareProducts') || '[]');

    if (compareProductsList.length > 0) {
      compareBanner.classList.add('half-open');
      this.initialCheckboxState();
      this.controlCheckboxLimit();
      this.updateSelectedCount();
      this.renderCompareDrawer();
    }

    this.toggleOpenButton = this.querySelector('.compare-banner__top-show-btn');
    this.toggleOpenButton.addEventListener('click', function() {
      compareBanner.classList.add('half-open');
      compareBanner.classList.toggle('open');
    });

    const buttonClearCheckedItems = this.querySelector('.compare-banner__top-btn-compare-clear');
    buttonClearCheckedItems.addEventListener('click', () => {
      compareCheckboxes.forEach((checkbox) => {
        checkbox.checked = false;
        checkbox.disabled = false;
      });

			if(selectedCounts.length) {
				selectedCounts.forEach((count) => {
					count.textContent = '(0)'; 
				})
			}
      localStorage.removeItem("compareProducts");
      compareProductsList = JSON.parse(localStorage.getItem('compareProducts')) || [];
      this.clearLocalStorage();
      this.controlCheckboxLimit();
      this.renderCompareDrawer();
      compareBanner.classList.remove('half-open');
      compareBanner.classList.remove('open');
    });

    this.addEventListener('click', function(event) {
      if (event.target.classList.contains('remove-compare-product') || event.target.closest('.remove-compare-product')) {

        const productId = event.target.getAttribute('data-product-id') || event.target.closest('.remove-compare-product').getAttribute('data-product-id');
        const checkboxes = document.querySelectorAll(`.product-compare-checkbox[data-product-id="${productId}"]`);
        
        checkboxes.forEach((checkbox) => {
          checkbox.checked = false;
        });
        this.removeFromLocalStorage(productId);
        this.updateSelectedCount();
        this.controlCheckboxLimit();
        this.renderCompareDrawer();
      }
    });

		this.resizeObserver = new ResizeObserver(this.updateHeightVariable);
    this.resizeObserver.observe(this);
    this.updateHeightVariable();
  }

	updateHeightVariable() {
    const height = this.offsetHeight;
    document.documentElement.style.setProperty('--compare-drawer-height', `${height}px`);
  }

	disconnectedCallback() {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
  }

  addCheckboxListeners(checkbox) {
		checkbox.addEventListener('change', (e) => {
			this.onChange(checkbox);
		});
  }

	onChange(checkbox) {
		const productID = checkbox.getAttribute('data-product-id');

		if (checkbox.checked) {
			this.updateLocalStorage(productID);
			const checkboxes = document.querySelectorAll(`.product-compare-checkbox[data-product-id="${productID}"]`);
			if (checkboxes.length) {
				checkboxes.forEach((checkbox) => {
					checkbox.checked = true;
				});
			}
		} else {
			this.clearDublicates(checkbox);
			this.removeFromLocalStorage(productID);
		}

		this.updateSelectedCount();
		this.controlCheckboxLimit();
		this.renderCompareDrawer();
		if (this.compareProductCount > 0) {
			this.classList.add('open');
		}
	}

  clearDublicates(checkbox) {
    const productId = checkbox.getAttribute('data-product-id');
    const checkboxes = document.querySelectorAll(`.product-compare-checkbox[data-product-id="${productId}"]`);
    checkboxes.forEach((checkbox) => {
      checkbox.checked = false;
    });
  }

  clearLocalStorage() {
    let compareProductsList = [];
    localStorage.setItem('compareProducts', JSON.stringify(compareProductsList));
    compareProductsList = JSON.parse(localStorage.getItem('compareProducts')) || [];
  }

  removeFromLocalStorage(productID) {
    let compareProductsList = JSON.parse(localStorage.getItem('compareProducts'));
    compareProductsList = compareProductsList.filter(product => product.productId !== productID);
    localStorage.setItem('compareProducts', JSON.stringify(compareProductsList));
  }

  updateLocalStorage(productID) {

    let compareProductsList = JSON.parse(localStorage.getItem('compareProducts')) || [];
    const checkedCheckbox = document.querySelector(`.product-compare-checkbox[data-product-id="${productID}"]`);

    const productId = checkedCheckbox.getAttribute('data-product-id');
    const url = checkedCheckbox.getAttribute('data-product-url');
    const productUrl = url.split('?')[0];

    if (!compareProductsList.some(product => product.productId === productID)) {
      compareProductsList.push({ productId, productUrl });
    }

    localStorage.setItem('compareProducts', JSON.stringify(compareProductsList));
    compareProductsList = JSON.parse(localStorage.getItem('compareProducts')) || [];
  }

  updateSelectedCount() {
    const compareProductsList = JSON.parse(localStorage.getItem('compareProducts')) || [];
    const selectedCounts = document.querySelectorAll('.compare-banner__top-counter');
    const compareButton = document.querySelector('.compare-banner__top-btn-compare');
    if (selectedCounts.length) {
			selectedCounts.forEach(count => {
				count.textContent = `(${compareProductsList.length})`;
			})
		}
    if (compareProductsList.length >= 2){
      compareButton.classList.remove('disabled');
    } else {
      compareButton.classList.add('disabled');
    }
  }

  controlCheckboxLimit() {
    let compareProductsList = JSON.parse(localStorage.getItem('compareProducts')) || [];
    const uniqueProductIds = new Set(compareProductsList.map(product => product.productId));
    const compareCheckboxes = document.querySelectorAll('.product-compare-checkbox');
  
    if (uniqueProductIds.size >= 4) {
      compareCheckboxes.forEach((checkbox) => {
        if (!checkbox.checked) {
          checkbox.classList.add('disabled');
          checkbox.setAttribute('disabled', '');
        }
      });
    } else {
      compareCheckboxes.forEach((checkbox) => {
        checkbox.classList.remove('disabled');
        checkbox.removeAttribute('disabled');
      });
    }
  }

  initialCheckboxState() {
    const compareProductsList = JSON.parse(localStorage.getItem('compareProducts'));
    compareProductsList.forEach(product => {
      document.querySelectorAll(`.product-compare-checkbox[data-product-id="${product.productId}"]`).forEach((checkbox) => {
        checkbox.checked = true;
      });
    });
  }

  static getSelectedProducts() {
    return JSON.parse(localStorage.getItem('compareProducts')) || [];
  }

  static async getDrawerProducts(compareProducts) {
    const tempHtml = {};
    await Promise.all(
      compareProducts.map(async (product) => {
        await fetch(`${product.productUrl}?sections=compare-drawer-product`)
          .then((response) => response.text())
          .then((html) => {
            tempHtml[product.productId] = html;
          });
      })
    );

    const returnHtml = [];
    compareProducts.forEach((product) => returnHtml.push(tempHtml[product.productId]));
    return returnHtml;
  }
  
  async renderCompareDrawer() {
    const compareProducts = CompareDrawer.getSelectedProducts();
    const compareProductCount = compareProducts.length;
    const placeholdersNeeded = Math.max(0, 4 - compareProductCount);
    this.compareBannerItems.innerHTML = '';
		this.compareProductCount = compareProductCount;
  
    if (compareProductCount > 0) {
      const compareProductHtmlArr = await CompareDrawer.getDrawerProducts(compareProducts);
  
      compareProductHtmlArr.forEach((html) => {
        const htmlObj = JSON.parse(html);
        const htmlString = htmlObj["compare-drawer-product"];
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = htmlString;
        const compareProductItem = tempDiv.querySelector('.compare-banner__product-item');
        this.compareBannerItems.appendChild(compareProductItem);
      });
    }
  
    for (let i = 0; i < placeholdersNeeded; i++) {
      const placeholder = document.createElement('div');
      placeholder.classList.add('compare-banner__product-item');
      placeholder.innerHTML = `<div class="compare-banner__product-item__empty-msg">Select product to compare</div>`;
      this.compareBannerItems.appendChild(placeholder);
    }

		if (compareProductCount === 0) {
      const compareItems = document.querySelectorAll('compare-modal, compare-drawer');
			compareItems.forEach((item) => {
				item.classList.remove('open');
				item.classList.remove('half-open');
      });
      document.body.classList.remove('overflow-hidden');
    }	
  }
}

customElements.define('compare-drawer', CompareDrawer);

class CompareModal extends HTMLElement {
  constructor() {
    super();
    const compareModal = this;
    const compareBanner = document.querySelector('compare-drawer.compare-banner');
    let compareProductsList = JSON.parse(localStorage.getItem('compareProducts') || '[]');

    this.compareArea = compareModal.querySelector('.compare-modal-content');
    const showModalButton = document.querySelector('.compare-banner__top-btn-compare');
    const closeModal = document.querySelector('.compare-modal-close');
    const selectedCounts = document.querySelectorAll('.compare-banner__top-counter');

    showModalButton.addEventListener('click', function() {
      compareModal.classList.add('open');

      document.body.classList.add('overflow-hidden');
      compareModal.renderCompareTable();
    });

    closeModal.addEventListener('click', function() {
      compareModal.classList.remove('open');
      document.body.classList.remove('overflow-hidden');
    });

    const clearProducts = this.querySelector('.clear-compare-modal-products');
    clearProducts.addEventListener('click', () => {

      compareModal.classList.remove('open');
      document.body.classList.remove('overflow-hidden');
      compareBanner.classList.remove('half-open');
      compareBanner.classList.remove('open');

      const compareCheckboxes = document.querySelectorAll('.product-compare-checkbox');
      compareCheckboxes.forEach((checkbox) => {
        checkbox.checked = false;
        checkbox.disabled = false;
      });
			if (selectedCounts.length) {
				selectedCounts.forEach((count) => {
					count.textContent = '(0)';
				})
			}

      localStorage.removeItem("compareProducts");
      compareProductsList = JSON.parse(localStorage.getItem('compareProducts')) || [];

      this.clearLocalStorage();
      this.updateSelectedCount();
      this.renderCompareDrawer();
      this.controlCheckboxLimit();
    });

    this.addEventListener('click', function(event) {
      if (event.target.classList.contains('remove-compare-product') || event.target.closest('.remove-compare-product')) {

        const productId = event.target.getAttribute('data-product-id') || event.target.closest('.remove-compare-product').getAttribute('data-product-id');
        const checkboxes = document.querySelectorAll(`.product-compare-checkbox[data-product-id="${productId}"]`);
        
        checkboxes.forEach((checkbox) => {
          checkbox.checked = false;
        });

        const compareProducts = document.querySelectorAll('.compare-product-modal');
        compareProducts.forEach((product) => {
          if (product.getAttribute('data-product-id') == productId) {
            product.remove();
          } 
        });

        this.removeFromLocalStorage(productId);
        this.updateSelectedCount();
        this.controlCheckboxLimit();
        this.renderCompareDrawer();
      }
    })
  }

  clearLocalStorage() {
    let compareProductsList = [];
    localStorage.setItem('compareProducts', JSON.stringify(compareProductsList));
    compareProductsList = JSON.parse(localStorage.getItem('compareProducts')) || [];
  }

  removeFromLocalStorage(productID) {
    let compareProductsList = JSON.parse(localStorage.getItem('compareProducts'));
    compareProductsList = compareProductsList.filter(product => product.productId !== productID);
    localStorage.setItem('compareProducts', JSON.stringify(compareProductsList));
  }

  updateSelectedCount() {
    const compareProductsList = JSON.parse(localStorage.getItem('compareProducts')) || [];
    const selectedCounts = document.querySelectorAll('.compare-banner__top-counter');
		
    const compareButton = document.querySelector('.compare-banner__top-btn-compare');
    if(selectedCounts.length) {
			selectedCounts.forEach(count => {
				count.textContent = `(${compareProductsList.length})`;
			})
		}
    if (compareProductsList.length >= 2){
      compareButton.classList.remove('disabled');
    } else {
      compareButton.classList.add('disabled');
    }
  }

  controlCheckboxLimit() {
    let compareProductsList = JSON.parse(localStorage.getItem('compareProducts')) || [];
    const uniqueProductIds = new Set(compareProductsList.map(product => product.productId));
    const compareCheckboxes = document.querySelectorAll('.product-compare-checkbox');
  
    if (uniqueProductIds.size >= 4) {
      compareCheckboxes.forEach((checkbox) => {
        if (!checkbox.checked) {
          checkbox.classList.add('disabled');
          checkbox.setAttribute('disabled', '');
        }
      });
    } else {
      compareCheckboxes.forEach((checkbox) => {
        checkbox.classList.remove('disabled');
        checkbox.removeAttribute('disabled');
      });
    }
  }
  

  static getSelectedProducts() {
    return JSON.parse(localStorage.getItem('compareProducts')) || [];
  }

  static extractCompareFields(html) {
    if (!html) return [];

    const container = document.createElement('div');
    container.innerHTML = html;
    return Array.from(container.querySelectorAll('[data-compare-key]'));
  }

  static async getModalProducts(compareProducts) {
    const tempHtml = {};

    await Promise.all(
      compareProducts.map(async (product) => {
        const productUrl = product.productUrl.split('?')[0];

        try {
          const sectionResponse = await fetch(`${productUrl}?sections=compare-product`);
          if (sectionResponse.ok) {
            const sectionData = await sectionResponse.json();
            const sectionHtml = sectionData['compare-product'];

            if (sectionHtml && sectionHtml.includes('data-compare-key')) {
              tempHtml[product.productId] = sectionHtml;
              return;
            }
          }
        } catch (error) {
          // Fall back to full product page parsing.
        }

        try {
          const response = await fetch(productUrl);
          if (!response.ok) return;

          const tmpl = document.createElement('template');
          tmpl.innerHTML = await response.text();

          const compareSection =
            tmpl.content.querySelector('.shopify-section .section-compare') ||
            tmpl.content.querySelector('.section-compare');

          if (compareSection) {
            const compareWrapper = compareSection.closest('.shopify-section');
            tempHtml[product.productId] = compareWrapper
              ? compareWrapper.outerHTML
              : compareSection.outerHTML;
          }
        } catch (error) {
          // Ignore failed product fetches.
        }
      })
    );

    return compareProducts
      .map((product) => tempHtml[product.productId])
      .filter(Boolean);
  }

  async renderCompareTable() {
    const loadingSpinner = this.querySelector('.loading__spinner');
    loadingSpinner.classList.remove('hidden');
    this.compareArea.innerHTML = '';

    const compareProducts = CompareModal.getSelectedProducts();

    if (compareProducts) {

      const compareProductHtmlArr = await CompareModal.getModalProducts(compareProducts);
      const compareFieldsArr = [];

      if (compareProductHtmlArr.length > 0) {

        this.compareArea.dataset.compareCount = compareProductHtmlArr.length;

        compareProductHtmlArr.forEach((compareProductHtml) => {
          CompareModal.extractCompareFields(compareProductHtml).forEach((compareField) => {
            if (!compareFieldsArr[compareField.dataset.compareKey]) {
              compareFieldsArr[compareField.dataset.compareKey] = [];
            }

            compareFieldsArr[compareField.dataset.compareKey].push(compareField);
          });
        });

        const compareElem = document.createElement('div');
        compareElem.className = 'compare-temp';

        Object.entries(compareFieldsArr).forEach(([key, value]) => {

          if (!value.every((elem) => !!elem.dataset.isEmptyMetafield)) {
            const compareRow = document.createElement('div');

            compareRow.className = `compare-row compare-row--${
              key.includes('metafield') ? 'metafield' : key.replace('compare-', '')
            }`;

            value.forEach((elem) => compareRow.appendChild(elem));
            compareElem.appendChild(compareRow);
          }
        });

        this.compareArea.innerHTML = compareElem.innerHTML;

      } else {
        this.compareArea.innerHTML = `Unable to compare products.${
          Shopify.designMode
            ? ' Ensure the Product Compare section is enabled.'
            : ' Please try again later.'
        }`;
      }

      setTimeout(() => {
        loadingSpinner.classList.add('hidden');
      }, 100);
    }
  }

  static async getDrawerProducts(compareProducts) {
    const tempHtml = {};
    await Promise.all(
      compareProducts.map(async (product) => {
        await fetch(`${product.productUrl}?sections=compare-drawer-product`)
          .then((response) => response.text())
          .then((html) => {
            tempHtml[product.productId] = html;
          });
      })
    );

    const returnHtml = [];
    compareProducts.forEach((product) => returnHtml.push(tempHtml[product.productId]));
    return returnHtml;
  }

  async renderCompareDrawer() {
    const compareProducts = CompareDrawer.getSelectedProducts();
    const compareProductCount = compareProducts.length;
    const placeholdersNeeded = Math.max(0, 4 - compareProductCount);
    const compareBannerItems = document.querySelector('.compare-banner__product-items');
    compareBannerItems.innerHTML = '';
  
    if (compareProductCount > 0) {
      const compareProductHtmlArr = await CompareDrawer.getDrawerProducts(compareProducts);
  
      compareProductHtmlArr.forEach((html) => {
        const htmlObj = JSON.parse(html);
        const htmlString = htmlObj["compare-drawer-product"];
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = htmlString;
        const compareProductItem = tempDiv.querySelector('.compare-banner__product-item');
        compareBannerItems.appendChild(compareProductItem);
      });
    }
  
    for (let i = 0; i < placeholdersNeeded; i++) {
      const placeholder = document.createElement('div');
      placeholder.classList.add('compare-banner__product-item');
      placeholder.innerHTML = `<div class="compare-banner__product-item__empty-msg">Select product to compare</div>`;
      compareBannerItems.appendChild(placeholder);
    }

    if (compareProductCount === 0) {
      const compareItems = document.querySelectorAll('compare-modal, compare-drawer');
			compareItems.forEach((item) => {
				item.classList.remove('open');
				item.classList.remove('half-open');
      });
      document.body.classList.remove('overflow-hidden');
    }
  }

}

customElements.define('compare-modal', CompareModal);


class CompareButton extends HTMLElement {
  constructor() {
    super();
    this.compareCheckbox = this.querySelector('.product-compare-checkbox');
		if (this.compareCheckbox) {
			this.compareDrawer.addCheckboxListeners(this.compareCheckbox);
			this.initialCheckboxState();
			this.controlCheckboxLimit();
			this.addEventListener('keydown', function(event) {										
				if (event.key === 'Enter' || event.key === ' ') {
					event.preventDefault();
					this.compareCheckbox.click();
				}
			});
		}
  }
}

CompareButton.prototype.compareDrawer = document.querySelector('compare-drawer');		

CompareButton.prototype.initialCheckboxState =  function() {
	const compareProducts = localStorage.getItem('compareProducts');
	if (!compareProducts) return;

	const compareProductsList = JSON.parse(localStorage.getItem('compareProducts'));

	if (compareProductsList) {
		compareProductsList.forEach(product => {
			if (product.productId == this.compareCheckbox.dataset.productId) {
				this.compareCheckbox.checked = true;
				return;
			}
		});
	}
}

CompareButton.prototype.controlCheckboxLimit =  function() {
	const compareProducts = localStorage.getItem('compareProducts');
	if (!compareProducts) return;

	const compareProductsList = JSON.parse(compareProducts);
	if(!compareProductsList || compareProductsList.length == 0) return;

	compareProductsList.forEach(product => {
		let compareProductsList = JSON.parse(localStorage.getItem('compareProducts')) || [];
    const uniqueProductIds = new Set(compareProductsList.map(product => product.productId));
  
    if (uniqueProductIds.size >= 4 && !this.compareCheckbox.checked) {
			this.compareCheckbox.classList.add('disabled');
			this.compareCheckbox.setAttribute('disabled', '');
    }
	});
}

customElements.define('compare-button', CompareButton);